import React, { useState, useEffect } from "react";
import CustomTable from "../../../core/custom-table";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import CustomButtonComponent from "../../../core/custom-button";
import { HeaderConfig } from "./config";
import ClaimsFilters from "../../oem/claims/claims-filters";
import { PAGE_LIMIT } from "../../../utils";

const AdminWarrantyClaims = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
  });

  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.CLAIMS}/admin`,
      null,
      { download: "TRUE" },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Claims.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.CLAIMS}/admin`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        <div>
          <p className="tab-name">Claims</p>
          <p className="section-name">Warranty Claims</p>
        </div>
      </div>
      <div>
        <div className="create-con">
          <p className="primary-text">Warranty Claim Form</p>
          <Box sx={{ display: "flex", gridGap: "20px" }}>
            <CustomButtonComponent
              variant="contained"
              color="success"
              onClick={downloadReports}
            >
              Download Claims
            </CustomButtonComponent>
          </Box>
        </div>
        <div className="si-hide-mobile">
          <CustomTable
            header={HeaderConfig}
            data={data.results || []}
            pageCount={data.totalPages}
            filters={filters}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            filterCom={<ClaimsFilters loadData={loadData} />}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
export default AdminWarrantyClaims;
